import React, { useState } from 'react';
import { EyeIcon, DuplicateIcon } from '@heroicons/react/outline';
import { Order } from '@Types/cart/Order';
//import InvoiceButton from 'components/commercetools-ui/invoice-button';
import { CurrencyHelpers } from 'helpers/currencyHelpers';
import { mapAddressToString } from 'helpers/utils/addressUtil';
import OrderDetailsModal from './modals/details-modal';
import ReorderModal from './modals/reorder-modal';
import UploadButton from '@Bic/components/commercetools-ui/business-unit/admin/panels/orders/buttons/uploadButton';

interface OrderWithHighlight extends Order {
  highlight?: boolean;
}
interface Props {
  orders: OrderWithHighlight[];
  useJdeId?: boolean
}

const OrderList: React.FC<Props> = ({ orders, useJdeId }) => {
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [isReorderModalOpen, setIsReorderModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  console.log(orders);
  const handleOpenDetailModal = (order) => {
    setSelectedOrder(order);
    setIsDetailsModalOpen(true);
  };

  const handleCloseDetailModal = () => {
    setSelectedOrder(null);
    setIsDetailsModalOpen(false);
  };

  const handleOpenReorderModal = (order) => {
    setSelectedOrder(order);
    setIsReorderModalOpen(true);
  };

  const handleCloseReorderModal = () => {
    setSelectedOrder(null);
    setIsReorderModalOpen(false);
  };
  
  return (
    <div>
      <table className="table-primary w-full table-fixed border">
        <thead>
          <tr>
            {/*<td>ID</td>*/}
            <td>Date</td>
            {!useJdeId && (
              <td>Shipping Address</td>
            )}
            {useJdeId && (
              <td>JDE Order Number</td>
            )}
            <td>Status</td>
            <td>Total price</td>
            <td>Order Tracking</td>
            <td style={{ width: '7%' }}></td>
          </tr>
        </thead>
        <tbody>
          {!!orders?.length &&
            orders.map((order) => (
              <tr key={order.orderId} className={order.highlight && 'highlight'}>
                {/*<td className="text-ellipsis-300" title={order.orderId}>
                  {useJdeId && order.custom.fields.bic_jde_ordernumber}
                  {!useJdeId && order.orderId}
                </td>*/}
                <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                {!useJdeId && (
                  <td className="text-ellipsis-300">{mapAddressToString(order.shippingAddress)}</td>
                )}
                {useJdeId && (
                  <td className="text-ellipsis-300">{order.custom?.fields.bic_jde_ordernumber}</td>
                )}
                <td className="text-ellipsis-150">{order.state?.name || order.orderState}</td>
                <td>{CurrencyHelpers.formatForCurrency({...order.sum, minimumFractionDigits: 2})}</td>
                <td className='text-ellipsis-150'><a href={order.custom?.fields.bic_order_tracking_field} target='blank'>{order.custom?.fields.bic_order_tracking_field}</a></td>
                <td className="mt-1 flex flex-row">
                  <button title="Details" onClick={() => handleOpenDetailModal(order)}>
                    <EyeIcon className="h-4 w-4" />
                  </button>
                  <button title="Reorder" onClick={() => handleOpenReorderModal(order)}>
                    <DuplicateIcon className="h-4 w-4" />
                  </button>
                  <UploadButton order={order} key={order.orderId} />
                  {/*<InvoiceButton order={order} />*/}
                </td>
              </tr>
            ))}
          {!orders?.length && (
            <tr>
              <td colSpan={8} className="text-center">
                No orders
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {isDetailsModalOpen && (
        <OrderDetailsModal onClose={handleCloseDetailModal} order={selectedOrder} open={isDetailsModalOpen} />
      )}
      {isReorderModalOpen && (
        <ReorderModal onClose={handleCloseReorderModal} open={isReorderModalOpen} order={selectedOrder} />
      )}
    </div>
  );
};

export default OrderList;
